<script>
  import { t9n } from '../lib/translate.js';
  import APIClient from '../state-charts/api-client';
  import Dialog from '../lib/components/Dialog.svelte';
  import { TS } from '../config/translation-keys.js';
  import session from '../lib/session.js';
  import Events from '../lib/events.js';
  import { show_message } from '../lib/flash';
  import router from '../lib/router';


  export let open_on_load = false;

  // translations ---------------------------------------------------------- //

  let title = t9n(
    TS.FIRST_TIME_TITLE,
    $session.merchant.service.selection_name
  );
  let content_line_1 = t9n(TS.FIRST_TIME_CONTENT_1);
  let content_line_2 = t9n(
    TS.FIRST_TIME_CONTENT_2,
    window.worker,
    window.orderer
  );
  let content = `<p>${content_line_1}</p><p>${content_line_2}</p>`;
  let orderer_button_label = t9n('label_orderer');
  let worker_button_label = t9n('label_worker');

  // utility functions ----------------------------------------------------- //

  const handle_worker_button_click = async e => {
    if ($session.user.approved_worker) {
      if ($session.tutorial === true) {
        document.tour.complete();
        document.tour = undefined;
      }
      await APIClient.switch_role({ is_worker: true, last_role: 'worker' });
      Events.dispatch("wp.roleswitcher.firstrole", {role: 'worker'})
      router.navigate('/settings?first_time=true');
    } else {
      show_message(t9n(TS.ERROR_NOT_APPROVED_WORKER), 'error');
    }
  };

  const handle_orderer_button_click = async e => {
    if ($session.user.approved_orderer) {
      if ($session.tutorial === true) {
        document.tour.complete();
        document.tour = undefined;
      }
      await APIClient.switch_role({ is_orderer: true, last_role: 'orderer' });
      Events.dispatch("wp.roleswitcher.firstrole", {role: 'orderer'})
      router.navigate('/settings?first_time=true');
    } else {
      show_message(t9n(TS.ERROR_NOT_APPROVED_ORDERER), 'error');
    }
  };

  let buttons = [
    {
      label: orderer_button_label,
      action: handle_orderer_button_click,
      classes: 'btn-orderer',
    },
    {
      label: worker_button_label,
      action: handle_worker_button_click,
      classes: 'btn-worker',
    },
  ];
</script>

<Dialog
  id="first-time-role-selector-dialog"
  {title}
  {content}
  {buttons}
  {open_on_load}
  modal={true} />

<style>
  .btn-worker,
  btn-worker:hover {
    background-color: var(--worker-background-color);
    color: var(--worker-foreground-color);
  }

  .btn-orderer,
  btn-orderer:hover {
    background-color: var(--orderer-background-color);
    color: var(--orderer-foreground-color);
  }
</style>
